// toast utility to publish notifications when configurations are saved
import { useEffect, useState } from 'react';

export interface ToastMessage {
  id: number;
  message: string;
}

// Simple pub-sub for toasts
const listeners: Array<(toast: ToastMessage) => void> = [];

export function showToast(message: string) {
  const toast: ToastMessage = {
    id: Date.now() + Math.random(),
    message,
  };
  listeners.forEach((fn) => fn(toast));
}

export function useToastSubscription() {
  const [toasts, setToasts] = useState<ToastMessage[]>([]);

  useEffect(() => {
    const handler = (toast: ToastMessage) => {
      setToasts((current) => [...current, toast]);
      // Auto-dismiss after 3s
      setTimeout(() => {
        setToasts((current) => current.filter((t) => t.id !== toast.id));
      }, 3000);
    };
    listeners.push(handler);
    return () => {
      const idx = listeners.indexOf(handler);
      if (idx > -1) listeners.splice(idx, 1);
    };
  }, []);

  return toasts;
} 